import { footerCustomer, footerInstitution, footerbrand, footersaved } from "../../assets/svg/index.js";

import { Twitter } from "../../assets/svg/index.js";
import { Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';

export const FooterData = [
  {
    image: footerbrand,
    title: "1,000+ Brands Partnered",
  },
  {
    image: footersaved,
    title: "Rs 1,800 Cr Saved",
  },
  {
    image: footerInstitution,
    title: "25 + Institutions Served",
  },
  {
    image: footerCustomer,
    title: "~ 50 Mn Customers Served",
  },
];

export const FooterLogoData = [
  {
    logo: <Facebook size={25} />,
    link: "https://www.facebook.com",
  },
  {
    logo: <Twitter size={25} />,
    link: "https://www.twitter.com",
  },
  {
    logo: <Linkedin size={25} />,
    link: "https://www.linkedin.com",
  },
  {
    logo: <Youtube size={25} />,
    link: "https://www.youtube.com",
  },
  {
    logo: <Instagram size={25} />,
    link: "https://www.instagram.com",
  },
];
